import { call, put, takeLatest } from 'redux-saga/effects'

import { LOGOUT } from '../actions'
import { actions } from '../api'
import { tearDownSession } from '../callApi'

export function* triggerLogoutSideEffects() {
  // wipe all kraken caches
  yield put(actions.wipe())
  // the logout method needs to be called that way to use the correct context
  yield call(tearDownSession)
}

export default function* watchLogoutActions() {
  yield takeLatest(LOGOUT, triggerLogoutSideEffects)
}
